// removed by extract-text-webpack-plugin
module.exports = {"container":"gV0Qwx1ViaTNs0KSS_8UC"};


//////////////////
// WEBPACK FOOTER
// ./src/Root/pages/Sections/style/Sections.pcss
// module id = 1291
// module chunks = 0